import { useState, useEffect } from "react";

/**
 * Custom hook that detects if the current viewport is mobile-sized
 * @param {number} breakpoint - The maximum width (in pixels) to consider as mobile (default: 768px)
 * @returns {boolean} True if the viewport is mobile-sized, false otherwise
 */
export const useIsMobile = (breakpoint: number = 767): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const updateIsMobile = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobile(e.matches);
    };

    updateIsMobile(mediaQuery);

    mediaQuery.addEventListener("change", updateIsMobile);

    return () => {
      mediaQuery.removeEventListener("change", updateIsMobile);
    };
  }, [breakpoint]);

  return isMobile;
};
